export default __webpack_public_path__ + "static/media/SpecializationExl.90e44602.xlsx";